/**
 * Converts a string from snake_case to kebab-case.
 * Non-string values are returned unchanged.
 *
 * @param {*} s - Value to convert (typically a string)
 * @returns {*} The string with underscores replaced by hyphens, or the original value
 * @example * snakeToKebab('snake_case') // -> 'kebab-case'
 */
function snakeToKebab(s) {
  return typeof s === 'string' ? s.replace(/_/g, '-') : s
}

export default snakeToKebab
